<div class="container-fluid">
  <div class="row section1 mt-4">
    <div class="col-12">
      <div class="row justify-content-between">
        <div class="col-12 col-md-auto">
          <h5 class="home-title">Surveys ({{pollsCount}})</h5>
          <p class="home-subtitle">Add new poll from here</p>
        </div>
        <div class="col-12 col-md-auto">
          <div class="dashboard-btn dashboard-manage">
            <div><a routerLink="/surveys/add-survey">
              <button class="btn btn-primary btn-dashboard"><i class="las la-poll"></i>Create new survey</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row section1">
  <div class="col-12">
    <div class="table-responsive applicants-details overflow-x-visible">
      <table class="table table-bordered user-table">
        <thead>
          <tr>
            <th scope="col">Question</th>
            <th scope="col">Options</th>
            <th scope="col">Status</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        @if (!!polls.length && !loading) {
          <tbody>
            @for (p of polls | paginate: { itemsPerPage: 10, currentPage: page, totalItems: pollsCount, id:'polls'}; track p; let pi = $index) {
              <tr class="client"
                >
                <td>{{p.questions[0].question}}</td>
                <td>
                  <mat-chip-set>
                    @for (o of p.questions[0].options; track o) {
                      <mat-chip color="primary">
                        @if (!!o.image) {
                          <img
                            class="rounded-circle mr-2"
                            style="object-fit: cover" width="20" height="20"
                            src="{{o.image}}" alt="">
                        }
                        {{o.option | capitalize}}
                      </mat-chip>
                    }
                  </mat-chip-set>
                </td>
                <td>{{p.status| uppercase}}</td>
                <td (click)="surveyAction(pi, p.status === 'published' ? 'paused' : 'published')" class="action text-primary pointer text-nowrap">
                  Mark as {{p.status === 'published' ? 'Paused' : 'Published'}}
                </td>
              </tr>
            }
          </tbody>
        }
        @if (loading) {
          <tbody>
            @for (q of loaders; track q; let qi = $index) {
              <tr class="client">
                <td>
                  <ngx-skeleton-loader [theme]="{height:'40px', width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                </td>
                <td>
                  <ngx-skeleton-loader [theme]="{height:'40px', width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader>
                </td>
                <td>
                  <ngx-skeleton-loader [theme]="{height:'40px', width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                </td>
                <td>
                  <ngx-skeleton-loader [theme]="{height:'40px', width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader>
                </td>
                <td>
                  <ngx-skeleton-loader [theme]="{height:'40px', width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                </td>
                <td>
                  <ngx-skeleton-loader [theme]="{height:'40px', width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                </td>
              </tr>
            }
          </tbody>
        }
      </table>
      @if (!loading && !polls?.length) {
        <div class="d-flex align-items-center justify-content-center py-5">
          No survey found
        </div>
      }
      <div class="float-right mt-3">
        <pagination-controls (pageChange)="pageChange($event)" id="polls"></pagination-controls>
      </div>
    </div>
  </div>
</div>
</div>
